/* CIMINY - Offres par quantité : comptes à rebours, panier, fiche produit, silhouette. YD Marketing & Data */
(function () {
  'use strict';
  var fmtMoney = function (cents) {
    var n = (cents / 100).toFixed(2).replace('.', ',');
    return n + ' €';
  };
  var plural = function (n, one, many) { return n > 1 ? many : one; };

  /* ---------- Comptes à rebours ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tickCountdowns() {
    var els = document.querySelectorAll('[data-co-countdown]');
    if (!els.length) return;
    var now = Date.now();
    els.forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-end'));
      if (isNaN(end)) return;
      var d = Math.max(0, end - now);
      var days = Math.floor(d / 86400000), h = Math.floor(d % 86400000 / 3600000), m = Math.floor(d % 3600000 / 60000), s = Math.floor(d % 60000 / 1000);
      var mode = el.getAttribute('data-co-countdown');
      if (mode === 'grid') {
        var set = function (k, v) { var t = el.querySelector('[data-cd="' + k + '"]'); if (t) t.textContent = pad(v); };
        set('d', days); set('h', h); set('m', m); set('s', s);
      } else {
        var parts = [];
        if (days > 0) parts.push(days + ' j');
        parts.push(pad(h) + ' h');
        parts.push(pad(m) + ' min');
        if (days === 0) parts.push(pad(s) + ' s');
        el.textContent = (d === 0 ? 'terminé' : parts.join(' '));
      }
    });
  }
  setInterval(tickCountdowns, 1000);
  document.addEventListener('DOMContentLoaded', tickCountdowns);
  tickCountdowns();

  /* ---------- Section panier (page /cart) : rafraîchissement ---------- */
  function refreshCartSections() {
    document.querySelectorAll('[data-co-cart-section]').forEach(function (wrap) {
      var id = wrap.getAttribute('data-co-cart-section');
      if (!id) return;
      wrap.setAttribute('aria-busy', 'true');
      fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-co-cart-section]');
          if (fresh) wrap.replaceWith(fresh);
          tickCountdowns();
        })
        .catch(function () { wrap.removeAttribute('aria-busy'); });
    });
  }

  /* ---------- Tiroir panier : injection de la barre des paliers ---------- */
  /* La barre vit DANS la zone qui défile (cart-drawer-items), jamais à côté : le pied du tiroir
     (total + bouton paiement) reste toujours visible. L'upsell est détaché et placé après les articles. */
  var drawerBusy = false;
  function placeInDrawer(drawer, fresh) {
    drawer.querySelectorAll('[data-co-drawer-bar], [data-co-drawer-up]').forEach(function (n) { n.remove(); });
    /* La fiche produit CIMINY re-rend le tiroir sans retirer la classe is-empty quand le panier était vide :
       on réaligne la classe sur le vrai contenu du panier, sinon les articles restent masqués. */
    var stateEl = fresh.querySelector('[data-co-cart-state]');
    var count = -1;
    try { count = stateEl ? JSON.parse(stateEl.textContent).items : -1; } catch (e) {}
    if (count > 0) {
      drawer.classList.remove('is-empty');
      var innerEl = drawer.querySelector('.drawer__inner');
      if (innerEl) innerEl.classList.remove('is-empty');
    } else if (count === 0) {
      drawer.classList.add('is-empty');
    }
    var items = drawer.querySelector('cart-drawer-items');
    var emptyBox = drawer.querySelector('.drawer__inner-empty');
    var isEmpty = drawer.classList.contains('is-empty');
    if (isEmpty && emptyBox) {
      var warn = emptyBox.querySelector('.cart-drawer__warnings');
      if (warn) warn.insertAdjacentElement('afterend', fresh); else emptyBox.prepend(fresh);
      return;
    }
    if (!items) return;
    var up = fresh.querySelector('.co-up');
    if (up) {
      var upWrap = document.createElement('div');
      upWrap.setAttribute('data-co-drawer-up', '');
      upWrap.className = 'co-up-wrap' + (fresh.querySelector('.co-cart--bf') ? ' co-up-wrap--bf' : '');
      upWrap.appendChild(up);
      items.appendChild(upWrap);
    }
    var form = items.querySelector('form');
    if (form) items.insertBefore(fresh, form); else items.prepend(fresh);
  }
  function loadDrawerBar() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawerBusy) return;
    drawerBusy = true;
    fetch('/?section_id=cim-cart-drawer-bar', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-co-drawer-bar]');
        if (!fresh) return;
        placeInDrawer(drawer, fresh);
        tickCountdowns();
        refreshPdpNudge();
      })
      .catch(function () {})
      .then(function () { drawerBusy = false; });
  }

  /* ---------- Fiche produit : phrase d'incitation selon le panier ---------- */
  function cartState() {
    var el = document.querySelector('[data-co-cart-state]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function nudgeText(n, tiers, eligible, bf) {
    if (!eligible) return null;
    var next = null, cur = null;
    tiers.forEach(function (t) { if (n + 1 >= t.q) cur = t; });
    tiers.forEach(function (t) { if (!next && n + 1 < t.q) next = t; });
    var txt;
    if (n === 0) {
      txt = 'Ajoutez-le, puis un deuxième article : <b>−' + tiers[0].r + ' %</b> s\'appliquent tout seuls dans le panier.';
      if (bf) txt = 'Black Friday : avec un deuxième article, <b>−' + tiers[0].r + ' %</b> sur les deux, automatiquement.';
    } else if (cur) {
      var reste = n + 1;
      txt = 'Vous avez déjà ' + n + ' ' + plural(n, 'article', 'articles') + ' dans le panier. Avec celui-ci, <b>−' + cur.r + ' %</b> sur vos ' + reste + ' articles.';
      if (next) txt += ' Encore ' + (next.q - reste) + ' et vous passez à −' + next.r + ' %.';
      else txt += ' C\'est le maximum.';
    } else {
      txt = 'Vous avez 1 article dans le panier. Avec celui-ci, <b>−' + tiers[0].r + ' %</b> sur les deux.';
    }
    return txt;
  }
  function refreshPdpNudge() {
    var box = document.querySelector('[data-co-pdp]');
    if (!box) return;
    var st = cartState();
    if (!st) return;
    var tiers = [];
    try { tiers = JSON.parse(box.getAttribute('data-tiers')); } catch (e) { return; }
    var eligible = box.getAttribute('data-eligible') === 'true';
    var bf = box.getAttribute('data-bf') === 'true';
    var el = box.querySelector('[data-co-nudge-text]');
    var txt = nudgeText(st.eligible, tiers, eligible, bf);
    if (el && txt) el.innerHTML = txt;
  }

  /* ---------- Silhouette : total avec le palier ---------- */
  function hookSilhouette() {
    var box = document.querySelector('[data-co-pdp]');
    var count = document.querySelector('[data-cp-sil-count]');
    var total = document.querySelector('[data-cp-sil-total]');
    if (!box || !count || !total) return;
    if (box.getAttribute('data-eligible') !== 'true') return;
    var tiers = [];
    try { tiers = JSON.parse(box.getAttribute('data-tiers')); } catch (e) { return; }
    var out = document.createElement('p');
    out.className = 'co-sil';
    out.setAttribute('aria-live', 'polite');
    total.insertAdjacentElement('afterend', out);
    var update = function () {
      var n = parseInt((count.textContent || '').replace(/\D/g, ''), 10);
      var cents = Math.round(parseFloat((total.textContent || '').replace(/[^\d,\.]/g, '').replace(',', '.')) * 100);
      if (!n || isNaN(cents)) { out.innerHTML = ''; return; }
      var cur = null, next = null;
      tiers.forEach(function (t) { if (n >= t.q) cur = t; });
      tiers.forEach(function (t) { if (!next && n < t.q) next = t; });
      if (cur) {
        var after = Math.round(cents * (100 - cur.r) / 100);
        out.innerHTML = '<b>−' + cur.r + ' %</b> appliqués au panier : <s>' + fmtMoney(cents) + '</s><b>' + fmtMoney(after) + '</b>' + (next ? '. Une pièce de plus et c\'est −' + next.r + ' %.' : '. Le palier maximum.');
      } else if (next) {
        out.innerHTML = 'Ajoutez ' + (next.q - n) + ' ' + plural(next.q - n, 'pièce', 'pièces') + ' de plus et <b>−' + next.r + ' %</b> s\'appliquent sur tout.';
      }
    };
    new MutationObserver(update).observe(count, { childList: true, characterData: true, subtree: true });
    new MutationObserver(update).observe(total, { childList: true, characterData: true, subtree: true });
    update();
  }

  var refreshTimer = null;
  function scheduleRefresh(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { refreshCartSections(); loadDrawerBar(); }, delay || 250);
  }

  document.addEventListener('DOMContentLoaded', function () {
    hookSilhouette();
    loadDrawerBar();
    var cd = document.querySelector('cart-drawer');
    if (cd) new MutationObserver(function (m) {
      /* Dawn remplace le contenu du tiroir après chaque mise à jour : on remet la barre */
      if (!cd.querySelector('[data-co-drawer-bar]') && !drawerBusy) loadDrawerBar();
    }).observe(cd, { childList: true, subtree: true });
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        /* le tiroir est re-rendu par Dawn juste avant/après : on laisse le DOM se poser */
        scheduleRefresh(200);
      });
    }
    /* fallback : interception des appels panier pour les thèmes/apps qui n'utilisent pas pubsub */
    var of = window.fetch;
    window.fetch = function (input, init) {
      var p = of.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
          p.then(function () { scheduleRefresh(400); });
        }
      } catch (e) {}
      return p;
    };
  });
})();
